import * as types from 'constants/actionTypes'

export function setIntegrationProducts (products) {
  return {
    type: types.SET_INTEGRATION_PRODUCTS,
    products
  }
}



// WEBPACK FOOTER //
// ./src/actions/integrationProductsAC.js